import { Vue, newVue } from '@/config/vue'

On.VueInit({
  controller: 'quiz',
  init() {
    const Quiz = Vue.component('quiz', () => import(/* webpackChunkName: "quiz" */ './Quiz.vue'))
    newVue({
      render: h => h(Quiz),
      mount: '#quiz',
    })
  },
})
